// extracted by mini-css-extract-plugin
module.exports = {"page":"_2HJrqVzU","bodyContainer":"_2K3jlPju","accountManagementSideBarContainer":"_262n-2ow","rightContent":"_1igFi9Q6"};